import React from 'react';
import { Briefcase, Clock, DollarSign } from 'lucide-react';

const LawyerFeesSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  if (!formData.includeLawyerFees) return null;

  // Рассчитываем общую стоимость услуг юриста
  const lawyerHourlyRate = parseFloat(formData.lawyerHourlyRate) || 0;
  const estimatedHours = parseFloat(formData.estimatedHours) || 0;
  const totalLawyerFees = lawyerHourlyRate * estimatedHours;

  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Briefcase className="w-5 h-5 mr-2 text-blue-500" />
        Услуги юриста/представителя
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Ставка юриста */}
        <div>
          <label htmlFor="lawyerHourlyRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <DollarSign className="w-4 h-4 mr-2 text-blue-500" />
            Ставка юриста (₽/час)
          </label>
          <input
            type="text"
            id="lawyerHourlyRate"
            name="lawyerHourlyRate"
            value={formData.lawyerHourlyRate}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.lawyerHourlyRate ? 'input-error' : ''}`}
            placeholder="Введите ставку в час"
          />
          {errors.lawyerHourlyRate && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.lawyerHourlyRate}
            </p>
          )}
        </div>

        {/* Ожидаемое количество часов */}
        <div>
          <label htmlFor="estimatedHours" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Clock className="w-4 h-4 mr-2 text-blue-500" />
            Количество часов
          </label>
          <input
            type="text"
            id="estimatedHours"
            name="estimatedHours"
            value={formData.estimatedHours}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.estimatedHours ? 'input-error' : ''}`}
            placeholder="Ожидаемое количество часов"
          />
          {errors.estimatedHours && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.estimatedHours}
            </p>
          )}
        </div>
      </div>

      {/* Итоговая стоимость услуг юриста */}
      <div className="mt-4 p-3 bg-blue-100 dark:bg-blue-900/40 rounded-lg">
        <div className="flex justify-between items-center">
          <span className="text-sm font-medium text-blue-700 dark:text-blue-300">
            Стоимость услуг юриста:
          </span>
          <span className="text-lg font-bold text-blue-800 dark:text-blue-200">
            {new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB', maximumFractionDigits: 0 }).format(totalLawyerFees)}
          </span>
        </div>
      </div>

      <div className="mt-4 text-xs text-blue-600 dark:text-blue-400">
        <p>
          <strong>Обратите внимание:</strong> Фактические расходы на юридические услуги могут отличаться в зависимости 
          от сложности дела, квалификации юриста и региона. При взыскании судебных расходов суд может уменьшить их 
          размер, если посчитает их чрезмерными.
        </p>
      </div>
    </div>
  );
};

export default LawyerFeesSection;